import React from "react";

export interface IconProps {
  width?: number;
  height?: number;
  color?: string;
}

export default function EmailShadowIcon(props: IconProps) {
  const { width, height, color } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || "121"}
      height={height || "96.261"}
      viewBox="0 0 121 96.261"
    >
      <g id="Illustration" transform="translate(-833.5 -361.943)">
        <g id="Email" transform="translate(834 362.443)">
          <g id="Shadow" transform="translate(0 86.762)">
            <ellipse
              id="Elipse_138"
              data-name="Elipse 138"
              cx="59.99"
              cy="4.499"
              rx="59.99"
              ry="4.499"
              fill="#ddd"
              opacity="0.5"
            />
          </g>
          <path
            id="Caminho_10351"
            data-name="Caminho 10351"
            d="M122-33.557a4.011,4.011,0,0,0-4-4H6a4.011,4.011,0,0,0-4,4V31.988a4.011,4.011,0,0,0,4,4H118a4.011,4.011,0,0,0,4-4Zm-4,0L58.728.155,6-33.557Z"
            transform="translate(-2 37.557)"
            fill={color || "#f9f9f9"}
          />
          <path
            id="Caminho_10350"
            data-name="Caminho 10350"
            d="M122-33.557a4.011,4.011,0,0,0-4-4H6a4.011,4.011,0,0,0-4,4V31.988a4.011,4.011,0,0,0,4,4H118a4.011,4.011,0,0,0,4-4Zm-4,0L58.728.155,6-33.557Zm0,65.545H6V-28.558L58.728,5.154,118-28.558Z"
            transform="translate(-2 37.557)"
            fill="#ddd"
            stroke="#ddd"
            stroke-width="1"
          />
        </g>
      </g>
    </svg>
  );
}
